export default "__VITE_ASSET__Np3L7pKa__"